import { VISUAL_SIZE, type Option, type Question } from '../types';
import { tv } from 'tailwind-variants';

type Props = Option & {
  handleClick: (id: string) => void;
  isSelected: boolean;
  isMultiSelect: boolean;
  visualSize?: Question['properties']['visualSize'];
};

const labelStyles = tv({
  base: 'mb-2 cursor-pointer rounded border border-solid p-3',
  variants: {
    withVisual: {
      true: 'flex items-center',
      false: 'block',
    },
    size: {
      [VISUAL_SIZE.SMALL]: '',
      [VISUAL_SIZE.LARGE]: '',
    },
    isSelected: {
      true: '',
    },
  },
  compoundVariants: [
    {
      withVisual: true,
      size: VISUAL_SIZE.SMALL,
      class: 'flex-row',
    },
    {
      withVisual: true,
      size: VISUAL_SIZE.LARGE,
      class: 'flex-col',
    },
    {
      withVisual: true,
      isSelected: true,
      class: 'bg-default-200',
    },
    {
      withVisual: true,
      isSelected: false,
      class: 'bg-inherit',
    },
  ],
});

const spanStyles = tv({
  base: 'cursor-pointer',
  variants: {
    size: {
      [VISUAL_SIZE.SMALL]: 'ml-3',
      [VISUAL_SIZE.LARGE]: 'mt-2 text-center',
    },
  },
  defaultVariants: {
    size: VISUAL_SIZE.SMALL,
  },
});

const imgStyles = tv({
  variants: {
    size: {
      [VISUAL_SIZE.SMALL]: 'size-10',
      [VISUAL_SIZE.LARGE]: 'size-14',
    },
  },
  defaultVariants: {
    size: VISUAL_SIZE.SMALL,
  },
});

const SelectInput = ({
  value,
  label,
  url,
  handleClick,
  isSelected,
  isMultiSelect,
  visualSize = 'small',
}: Props) => {
  const onClickInput = (event: React.MouseEvent) => {
    event.stopPropagation();
    handleClick(value);
  };

  const onChangeInput = () => {
    handleClick(value);
  };

  return (
    <label
      htmlFor={value}
      className={labelStyles({
        isSelected,
        withVisual: !!(url && visualSize),
        size: visualSize,
      })}
    >
      {url && <img src={url} className={imgStyles({ size: visualSize })} />}
      <input
        type={isMultiSelect ? 'checkbox' : 'radio'}
        id={value}
        checked={isSelected}
        value={value}
        className={
          url
            ? 'sr-only cursor-pointer accent-secondary-50'
            : 'cursor-pointer accent-secondary-50'
        }
        onClick={onClickInput}
        onChange={onChangeInput}
      />
      <span className={spanStyles({ size: visualSize })}>{label}</span>
    </label>
  );
};

export default SelectInput;
